import {DisplayDecimal, DisplayDecimalWithOptCurrency} from '../../../../components/symbol-decimals';
import {OrderTransactionType} from '../../../../enums/order-transaction-type';
import {SecurityKey} from '../../../../models/security-key';

export interface WidgetOrderConfirmModalInfo {
    title: string;
    side?: string;
    quantity?: DisplayDecimalWithOptCurrency;
    price?: DisplayDecimal;
    security: SecurityKey;
    accountNames?: string[];
    closedOrdersCount?: number;
    isNeedToHaveAnAccount?: boolean;
    isListenToQuotesEnabled?: boolean;
    isExchangeNotAllowedToTrade?: boolean;
    isPortfolioNeeded?: boolean;
}

export const CANCEL_ORDER_CONFIRMATION_TITLE = 'components.widget-order-confirm-modal.cancel_order';

export const ORDER_CONFIRMATION_TITLE_BY_TRANSACT_TYPE: {[transactionType in OrderTransactionType]: string} = {
    [OrderTransactionType.NEW]:     'components.widgets.trade-widget.place_order',
    [OrderTransactionType.REPLACE]: 'components.widgets.order-details-widget.replace_order',
    [OrderTransactionType.CANCEL]:  'components.widgets.order-details-widget.cancel_order'
};

export const EXCHANGE_SUPPORT_CONFIRMATION_TITLE = 'components.widget-order-confirm-modal.exchange_support_title';
export const CREATE_ACCOUNT_CONFIRMATION_TITLE = 'components.widget-order-confirm-modal.create_account_title';
export const SELECT_PORTFOLIO_CONFIRMATION_TITLE = 'components.widget-order-confirm-modal.portfolio_select_title';
